/**
 * Test IDs for QA automation.
 */
export const testIds = {
  trailerCompartmentAssignmentFormTrailer: "trailer-compartment-assignment-form-trailer",
  trailerCompartmentAssignmentFormCommodity: "trailer-compartment-assignment-form-commodity",
  trailerCompartmentAssignmentFormVolume: "trailer-compartment-assignment-form-volume",
  trailerCompartmentAssignmentFormNone: "trailer-compartment-assignment-form-none",
  trailerCompartmentAssignmentFormCommodityMenuItem: (goodProfileId: string) =>
    `trailer-compartment-assignment-form-commodity-menu-item-${goodProfileId}`,
} as const;
